import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';
import { selectTokens } from '../../features/authSlice';
import { notificationsChanged } from '../../features/mainSlice';
import { useGetNotificationsQuery } from '../../services/main';
import { useGetEnvQuery } from '../../services/common';

export default function Home() {
  const dispatch = useAppDispatch();
  const tokens = useAppSelector(selectTokens);

  const navigate = useNavigate();
  const { state, pathname } = useLocation();

  const lastPath = pathname.split('/').pop();

  const { data: notifications } = useGetNotificationsQuery();
  const { data: env, isLoading: isEnvLoading } = useGetEnvQuery();

  useEffect(() => {
    if (!tokens.accessToken) {
      navigate('/login', { state: { lastPath } });
    }
  }, [tokens, navigate, lastPath]);

  useEffect(() => {
    dispatch(notificationsChanged(notifications));
  }, [dispatch, notifications]);

  useEffect(() => {
    if (env) {
      const links: HTMLLinkElement[] = [];

      env.CSS.forEach((url: string) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        document.head.appendChild(link);
        links.push(link);
      });

      return () => {
        links.forEach((link) => {
          if (link.parentNode) {
            link.parentNode.removeChild(link);
          }
        });
      };
    }
  }, [env]);

  if (state?.isSharedLink || isEnvLoading) return null;

  return (
    <>
      <Header />
      <Outlet></Outlet>
    </>
  );
}
